import { DestinationCustomerRequest } from "./destination-customer-request";

export class DestinationRequest {
    customer: DestinationCustomerRequest;

    constructor(customer?: DestinationCustomerRequest) {
        this.customer = customer ? customer : new DestinationCustomerRequest();
    }
}